import Request from "../../utils/Request";
import {AxiosResponse} from "axios";

/**
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
const BulkEmployers = (data = {}): Promise<AxiosResponse<any>> => Request.post(`/advisors/employer/bulk-employers`, data);

export default BulkEmployers;